import axios from "axios";
import { BalanceRequest, CheckInRequest, CreateTokenRequest } from "../types";
import { STORAGE_KEY } from "../constants";

const baseURL = process.env.REACT_APP_BASE_URL;
const instance = axios.create({ baseURL });
const API_URL = "/multifamily/smart-check-in";

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(STORAGE_KEY.TOKEN);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const createToken = (request: CreateTokenRequest) => instance.post(`${API_URL}/token`, request);
export const getConfig = () => instance.get(`${API_URL}/config`);
export const getBooking = () => instance.get(`${API_URL}/booking`);
export const searchBooking = (hotel_id: string, rsvn_no: string, name: string) =>
  instance.get(`${API_URL}/pms_bookings/${rsvn_no}/1/${name}/${hotel_id}`);

// policy-agree
export const getTerms = () => instance.get(`${API_URL}/terms_templates`);

// room
export const getRoomList = () => instance.get(`${API_URL}/check-in/rooms/available`);

// checkIn
export const getCheckInBalance = () => instance.get(`${API_URL}/check-in/check`);
export const checkIn = (request: CheckInRequest) => instance.post(`${API_URL}/check-in`, request);
export const getAnnouncements = () => instance.get(`${API_URL}/announcement`);

// checkOut
export const getCheckOutBalance = () => instance.get(`${API_URL}/check-out/check`);
export const checkOut = (request: BalanceRequest) => instance.post(`${API_URL}/check-out`, request);
